import {
    CHANGE_USERNAME_OPEN_MODAL,
    CHANGE_USERNAME_CLOSE_MODAL,
    CHANGE_USERNAME_UPDATE_REQUEST,
    CHANGE_USERNAME_UPDATE_RESULT,
} from 'Redux/actionTypes';

export const changeUsernameOpenModal = (data) => ({
    type: CHANGE_USERNAME_OPEN_MODAL,
    payload: data
})

export const changeUsernameCloseModal = () => ({
    type: CHANGE_USERNAME_CLOSE_MODAL
})

export const changeUsernameUpdateRequest = (data) => ({
    type: CHANGE_USERNAME_UPDATE_REQUEST,
    payload: data
})

export const changeUsernameUpdateResult = (result) => ({
    type: CHANGE_USERNAME_UPDATE_RESULT,
    payload: result
})